import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    newPath: String
  }

  connect() {
    this.boundOnFrameLoad = this.onFrameLoad.bind(this)
  }

  open(event) {
    event?.preventDefault()
    event?.stopPropagation()

    const frame = document.getElementById("report_modal")
    if (!frame) return

    const loaded = frame.querySelector("#report_modal_content") !== null
    if (loaded) {
      this.dispatchOpen()
      return
    }

    this.setLoading(true)
    frame.setAttribute("src", this.newPathValue)
    frame.dataset.reportPendingOpen = "true"
    frame.addEventListener("turbo:frame-load", this.boundOnFrameLoad, { once: true })
  }

  onFrameLoad() {
    this.setLoading(false)
    const frame = document.getElementById("report_modal")
    if (frame) delete frame.dataset.reportPendingOpen
  }

  dispatchOpen() {
    document.dispatchEvent(new CustomEvent("report:open"))
  }

  setLoading(loading) {
    const button = this.element
    if (!(button instanceof HTMLButtonElement)) return

    if (loading) {
      button.disabled = true
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.innerHTML
      }
      button.innerHTML = "Загрузка…"
    } else {
      button.disabled = false
      if (button.dataset.originalText) {
        button.innerHTML = button.dataset.originalText
      }
    }
  }
}
